import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import CaseList, { DispatchProps, OwnProps, StateProps } from './CaseList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getCases } from 'src/store/actions/case-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameSerTypesDropDown } from '../../../../../../store/selectors/service-types-selectors';
import { getStudentsSmall } from '../../../../../../store/actions/student-actions';
import { getVendorsSmall } from '../../../../../../store/actions/vendor-actions';
import { getDistrictsSmall } from '../../../../../../store/actions/district-actions';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.cases.data,
        inProgress: state.cases.inProgress,
        students: selectNameStudents(state),
        providers: selectNameProviders(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        serviceTypes: selectNameSerTypesDropDown(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getCases(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const CaseListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseList);

export default CaseListScreen;
